export default function scrollTo(element: HTMLElement | null) {
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }
}
